import type { discretoPt } from './discreto-pt';

export const discretoEs: typeof discretoPt = {
  discreto: {
    ocultar: 'Ocultar valores',
    mostrar: 'Mostrar valores',
    estadoLigado: 'Activado',
    dica: '{{acao}} ({{atalho}})',
    valorOculto: 'valor oculto',
    campoOculto: '{{rotulo}}: valor oculto',
    ligado: 'Modo discreto activado. Valores ocultos.',
    desligado: 'Modo discreto desactivado. Valores visibles.',
    preferencias: 'Preferencias del modo discreto',
    noAparelho: 'Estas preferencias se guardan solo en este dispositivo.',
    atalho: 'Atajo de teclado: {{atalho}} activa y desactiva el modo discreto en cualquier pantalla.',
    inatividade: 'Activar solo tras un tiempo sin uso',
    inatividadeAjuda: 'Sin tocar el ratón ni el teclado durante ese tiempo, los valores quedan ocultos. Escribir o hacer clic dentro del marco de un enlace externo cuenta como uso; con el foco quieto dentro del marco, ese tiempo solo empieza a contar después de 15 minutos.',
    inatividadeDesligado: 'Desactivado',
    minutos_one: '{{count}} minuto',
    minutos_other: '{{count}} minutos',
    nomes: 'Ocultar también nombres de personas y empresas',
    nomesAjuda: 'Muestra solo las iniciales.',
    exportarTitulo: 'Modo discreto activado',
    exportarAviso: 'El archivo sale con los valores reales.',
    imprimirAviso: 'El certificado sale con el nombre real.',
    copiarTitulo: 'Modo discreto activado',
    copiarAviso: 'El texto copiado lleva los valores reales.',
    secao: 'Modo discreto',
    secaoAjuda: 'Oculta valores, documentos y contactos en la pantalla, como el ojo de las apps bancarias. El botón de ojo en la barra superior lo activa y desactiva.',
  },
};
